global.API_BASE = 'https://hidden-chamber-75126.herokuapp.com'
global.name = localStorage.getItem('name')

export default global;